<template>
  <div style="height: 80vh" class="test_red">
    <header>
      <MenuHeaderPublic />
    </header>
    <!--    <div height="100vh">-->
    <main class="pt-16 fill-height">
      <v-container class="test_yellow container-home">
        <v-row no-gutters>
          <!--          <v-col v-if="$store.getters.appInfo.storeSearchRequired" cols="12">-->
          <!--            <PlaceAutocompleteNearStore />-->
          <!--          </v-col>-->
          <v-col v-if="$store.getters.appInfo.storeListRequired">
            <StoresListSection />
          </v-col>
        </v-row>
      </v-container>
      <MetaDataComponent
        v-if="metaTitle && metaDescription && metaKeywords"
        :title="metaTitle"
        :description="metaDescription"
        :keywords="metaKeywords"
      />
    </main>
    <!--    </div>-->
    <FooterComponent />
  </div>
</template>

<script>
/*
Actions:
  Meta name in the tab-translation
  Banner from API layout
  Search store status  from API layout
  Store list status  from API layout
  Delete store info
  Home status-redirect
*/
import MetaDataComponent from "@/components/metaDataComponent/MetaDataComponent";
import FooterComponent from "@/views/front/home/components/FooterComponent";
export default {
  layout: "Public",
  name: "Home",
  components: {
    MetaDataComponent,
    FooterComponent,
    StoresListSection: () => import("./components/StoresListSection.vue"),
  },
  computed: {
    banner: {
      get() {
        return this.$store.getters.appInfo
          ? this.$store.getters.appInfo.banner
          : require("@/assets/img/home/background.jpg");
      },
      set(val) {
        return val;
      },
    },
    appInfo: function () {
      return this.$store.getters.appInfo;
    },
    tiktok: {
      get() {
        return require("@/assets/img/home/tiktok.jpeg");
      },
    },
    metaTitle() {
      return this.$store.getters.appInfo.metaTitle;
    },
    metaDescription() {
      return this.$store.getters.appInfo.metaDescription;
    },
    metaKeywords() {
      return this.$store.getters.appInfo.metaKeywords;
    },
  },
  beforeMount() {
    if (!this.$store.getters.appInfo.requireHomePage) {
      this.$router.push({
        name: "Discovery",
        params: { id: this.$store.getters.appStoresList[0].slug },
      });
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch("storeInfo/setStoreInfo", null);
      this.$appPageTitle.tab(this.$route.name);
    });
  },
  methods: {
    openSocialUrl(url) {
      window.open(url);
    },
  },
  // metaInfo() {
  //   return this.metaInfo;
  // },
};
</script>
<style lang="scss" scoped>
.container-home {
  max-width: 1400px !important;
  margin: 0 auto;
}

@media screen and (max-width: 960px) {
  .container-home {
    max-width: none;
    padding: 0 15px !important;
  }
}
@media screen and (max-width: 640px) {
  .footer {
    flex-direction: column-reverse !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1400px) {
  .container-home {
    padding: 0 30px !important;
  }
}
.footer {
  background-color: #ffffff;
  height: 20vh;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #c9c5c5;
  justify-content: center;
  align-items: center;
}
.separator {
  height: 1px;
  background-color: #c9c5c5;
  margin-bottom: 20px;
}

.content-x {
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.social-icons {
  //right: 20px;
  //margin-right: 25px;
  //position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.left-links {
  //left: 20px;
  ////margin-right: 25px;
  //position: absolute;
}

.social-icon {
  display: inline-block;
  font-size: 20px;
  color: #333;
}

.social-icon:hover {
  color: #007bff;
}
</style>
